import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LingkWriterForm from '../forms/lingk-writer-form';
import { lingkWriterValidationSchema } from '../schema/lingkWriter.js';

export default function LingkWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Lingk Writer Node Details',
        altText: 'Lingk Writer Node',
        defaultLabel: 'Lingk Writer Node',
      }}
    >
      <CommonNode FormComponent={LingkWriterForm} schemaResolver={lingkWriterValidationSchema} />
    </NodeProvider>
  );
}
